import { render } from "./IconAddCircle.vue?vue&type=template&id=276c3d81"
import script from "./IconAddCircle.vue?vue&type=script&lang=js"
export * from "./IconAddCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__